import logger from 'utils/logger-aws'
import { DynamicComponentProps } from '~types'
import { enhanceComponentBlock } from 'utils/transform/enhanceComponentBlock'
import * as Modules from '~modules'
import * as Elements from '~elements'

const DynamicComponent = ({ block, isChildOfModal = false }: DynamicComponentProps) => {
  const aliasMap: Record<string, string> = {
    ContentHeading: 'Heading',
    CohortVotingButton: 'CohortVotingButtonGroup', // renamed for better readability
    CalendarEDP: 'Calendar',
    ShowsCalendar: 'Calendar'
  }

  const rawName = block?.componentName
  const componentName = (rawName && aliasMap[rawName]) ?? rawName

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const modules = Modules as Record<string, React.ComponentType<any>>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const elements = Elements as Record<string, React.ComponentType<any>>

  const Component = componentName ? modules[componentName] || elements[componentName] : undefined

  if (!Component) {
    const isEmptyObject = block && Object.keys(block).length === 0
    const message = `[DynamicComponent] ❌ "${block.componentName}" not found in components list.${
      isEmptyObject ? ' Empty block object detected; check for unsupported components in Hygraph.' : ''
    }`
    console.error(message)
    logger.error(message)
    return null
  }

  const enhancedBlock = enhanceComponentBlock(block, isChildOfModal)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Component {...(enhancedBlock as any)} />
}

export default DynamicComponent
